var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M127.8,146.9c-18.4,0-35.8-7.2-48.8-20.2c-13.1-13-20.2-30.4-20.2-48.8c0-18.4,7.2-35.8,20.2-48.8C92,16,109.3,8.8,127.8,8.8s35.8,7.2,48.8,20.2c13,13.1,20.2,30.4,20.2,48.8c0,18.4-7.2,35.8-20.2,48.8C163.5,139.7,146.2,146.9,127.8,146.9z M127.8,25.9c-28.7,0-52,23.3-52,52s23.3,52,52,52c28.7,0,52-23.3,52-52C179.7,49.2,156.4,25.9,127.8,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M212.3,170.5c-10.9-10.9-23.6-19.5-37.7-25.5c-4.3-1.8-9.3,0-11.2,4.3c-2,4.4,0,9.5,4.5,11.4c12.2,5.2,23.1,12.5,32.5,21.9c9.4,9.4,16.7,20.3,21.9,32.5c3.4,8,5.7,16.3,6.9,24.8c0.6,4.2,4.2,7.3,8.4,7.3l0,0c5.2,0,9.2-4.6,8.5-9.7c-1.5-9.9-4.2-19.6-8.1-29C231.8,194.2,223.2,181.5,212.3,170.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M34,215.1c5.2-12.2,12.5-23.1,21.9-32.5c9.4-9.4,20.2-16.7,32.3-21.9c4.3-1.8,6.5-7,4.6-11.3c-1.9-4.3-6.8-6.2-11.1-4.4c-14.2,6-26.9,14.6-37.9,25.6c-10.9,11-19.5,23.7-25.5,37.9c-3.9,9.3-6.6,19-8.1,29c-0.7,5.2,3.3,9.7,8.5,9.7l0,0c4.2,0,7.8-3.1,8.4-7.3C28.3,231.3,30.6,223,34,215.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7499f55aa2a73c2c9dc331e43d69164d.svg";
export { ForwardRef as ReactComponent };